// Session SC7A (Repairs, To fix): the words and tones for where a defect came from and what has happened to it.
// The values are derived live on the server (server/src/modules/defects/fixStateDerive.ts); this file only names them.
// Tone rule (src/lib/statusRegistry.ts): green done, blue in hand or waiting on someone outside, amber needs the office,
// grey neutral. The pill always shows the words too, so colour is never the only signal.
import type { DefectFixState, DefectOrigin } from "./api";
import type { PillTone } from "../components/StatusPill";
import type { StateKind } from "./statusRegistry";

export const DEFECT_ORIGIN_OPTIONS: { value: DefectOrigin; label: string }[] = [
  { value: "visit", label: "Visit" },
  { value: "callout", label: "Call-out" },
  { value: "loler", label: "LOLER report" },
  { value: "insurer", label: "Insurer" },
  { value: "office", label: "Logged by the office" },
];

export const DEFECT_ORIGIN_LABEL: Record<DefectOrigin, string> = Object.fromEntries(DEFECT_ORIGIN_OPTIONS.map((o) => [o.value, o.label])) as Record<DefectOrigin, string>;

export const DEFECT_FIX_STATE_OPTIONS: { value: DefectFixState; label: string }[] = [
  { value: "no_estimate", label: "No estimate yet" },
  { value: "estimate_sent", label: "Awaiting customer approval" },
  { value: "approved", label: "Estimate approved" },
  { value: "declined", label: "Estimate declined" },
  { value: "job_raised", label: "Job raised" },
  { value: "job_booked", label: "Job booked" },
  { value: "paused", label: "On hold" },
  { value: "job_done", label: "Job done: confirm the fault is gone" },
  { value: "done", label: "Done" },
];

export const DEFECT_FIX_STATE_LABEL: Record<DefectFixState, string> = Object.fromEntries(DEFECT_FIX_STATE_OPTIONS.map((o) => [o.value, o.label])) as Record<DefectFixState, string>;

export const DEFECT_FIX_STATE_TONE: Record<DefectFixState, PillTone> = {
  no_estimate: "amber",
  estimate_sent: "blue",
  approved: "amber",
  declined: "amber",
  job_raised: "amber",
  job_booked: "blue",
  paused: "amber",
  job_done: "amber",
  done: "green",
};

/** The fix states that are one of the shared state looks (statusRegistry.ts STATE_LOOK), so the To fix queue draws them with the same icon as every other list (Session SC9A). */
export const DEFECT_FIX_STATE_KIND: Partial<Record<DefectFixState, StateKind>> = {
  paused: "on_hold",
  estimate_sent: "awaiting_approval",
};

export function isDefectOrigin(v: string | null): v is DefectOrigin {
  return v === "visit" || v === "callout" || v === "loler" || v === "insurer" || v === "office";
}

export function isDefectFixStateFilter(v: string | null): v is DefectFixState | "to_do" {
  return v === "to_do" || DEFECT_FIX_STATE_OPTIONS.some((o) => o.value === v);
}
